
<template>
  <div class="main-content-wrapper content-width-1300">
    <ChapterDirectory @handleChange="_directoryChange" @handleLimit="_limit" />
    <div class="synchronous-right-box">
      <div
        class="synchronous-resource-list"
        v-loading="listLoading"
        element-loading-text="数据正在跑步前进中"
        element-loading-spinner="el-icon-loading"
        element-loading-background="grba(255, 255, 255, 0.5)"
        >
        <div class="resource-list-box" v-if="dataList.length">
          <resource-item 
            v-for="(item, index) in dataList" 
            :key="index+'-'+item.resourceId" 
            :item="item" 
            component-type="synchronous"
            @handlePlay="_play"
            @handleLimit="_limit"
            >
            <span v-if="(accountInfo && accountInfo.needBinding && item.isFree) || (!accountInfo && item.isFree)" class="free-tip" slot="topLeft">试看</span>
            </resource-item>
        </div>
        <div class="resource-list-box empty" v-else-if="!dataList.length && !listLoading">
          <img src="../../assets/resource-empty.png" alt class="empty-img" />
          <p>暂无数据~</p>
        </div>
        <!-- 分页 -->
        <el-pagination
          v-if="pageTotal && pageTotal > pageSize"
          id="elPagination1"
          layout="total, prev, pager, next"
          :current-page="pageNum"
          :total="pageTotal"
          :page-size="pageSize"
          :disabled="!isLogin"
          @current-change="_pageNumChange"
        ></el-pagination>
      </div>
    </div>
    
    <!-- 弹框 -->
    <LimitDialog :visible="operateDialogVisible" @handleClick="_closeDialog" />
  </div>
</template>
<script>
import store from 'store';
import { mapState } from "vuex";
import { preventRepeatMessage } from "utils/util";
import ChapterDirectory from "./chapter-directory";
import ResourceItem from 'components/resource-item';
import LimitDialog from 'components/limit-dialog';
import { reqGetResourceList } from 'api/synchronous-courses';
export default {
  name: 'SynchronousCourses',
  components: {
    ChapterDirectory,
    ResourceItem,
    LimitDialog
  },
  data() {
    return {
      listLoading: true,
      pageTotal: 0,
      pageSize: 9,
      pageNum: 1,
      dataList: [],
      directoryObj: {},
      operateDialogVisible: false
    };
  },
  computed: {
    ...mapState(["accountInfo", "isLogin"])
  },
  methods: {
    _closeDialog(flag = true) {
      this.operateDialogVisible = flag;
    },
    /**
     * 未登录时的提示
     * **/
    _limit() {
      this.operateDialogVisible = true;
    },
    /**
     * 左侧目录change
     * **/
    _directoryChange(data, type) {
      if(!data) {
        return this.listLoading = false;
      }
      let _data = Object.assign({}, data);
      if(type === 'chapter' && _data.chapterOneId == this.directoryObj.chapterOneId && _data.chapterTwoId == this.directoryObj.chapterTwoId && _data.chapterThreeId == this.directoryObj.chapterThreeId) {
        return;
      }
      this.directoryObj = _data;
      this.pageNum = 1;
      this._getDataList();
    },
    _play(item) {
    },
    /**
     * 页数change
     * **/
    _pageNumChange(val) {
      if(!this.isLogin) {
        return;
      }
      this.pageNum = val;
      this._getDataList('pageChange');
    },
    /**
     * 获取数据
     * **/
    _getDataList(type) {
      // return this.listLoading = false;;
      let obj = {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        subjectId: this.directoryObj.subjectId,
        editionId: this.directoryObj.editionId,
        volumeId: this.directoryObj.volumeId,
      };
      if(this.directoryObj.chapterOneId) {
        obj.chapterOneId = this.directoryObj.chapterOneId;
        if(obj.chapterOneId === -1) {
          obj.chapterOneId = null;
        }
      }
      if(this.directoryObj.chapterTwoId) {
        obj.chapterTwoId = this.directoryObj.chapterTwoId;
      }
      if(this.directoryObj.chapterThreeId) {
        obj.chapterThreeId = this.directoryObj.chapterThreeId;
      }
      this.listLoading = true;
      this.dataList = [];
      if(type !== 'pageChange') {
        this.pageTotal = 0;
      }
      return reqGetResourceList(obj)
        .then(res => {
          this.listLoading = false;
          if (res.code === 0) {
            this.dataList = res.data.datas;
            this.pageTotal = res.data.totalCount;
            if(!this.isLogin) {
              this._setPaginationCss();
            }
          }else if(res.code === 14001) {
            store.commit('LOGOUT', null);
            preventRepeatMessage();
            setTimeout(() => {
              this.$router.replace({
                path: '/home-page',
                query: {
                  redirect: this.$route.path,
                  reload: true
                }
              });
            }, 500);
          } else {
            this.dataList = [];
            this.pageTotal = 0;
            this.$message({
              type: "error",
              message: "数据获取失败",
              duration: 2000
            });
          }
        })
        .catch(err => {
          this.listLoading = false;
          this.dataList = [];
          this.pageTotal = 0;
          console.log("数据获取失败", err);
        });
    },
    /**
     * 未登录时限制翻页
     * **/
    _setPaginationCss() {
      let _this = this;
      this.$nextTick(() => {
        $('#elPagination1 .btn-next').eq(0).removeAttr('disabled');
        $('#elPagination1 .btn-next').eq(0).addClass('btn-readonly');
        $('#elPagination1 .btn-next').eq(0).on('click', function(event) {
          _this._limit();
          console.log('not login', _this.isLogin);
          event.stopPropagation();
          event.preventDefault();
          return false;
        });
        $('#elPagination1 .el-pager li').each(function() {
          $(this).addClass('pager-readonly');
          $(this).not('.active').on('click', function(event) {
            _this._limit();
            console.log('not login', _this.isLogin);
            event.stopPropagation();
            event.preventDefault();
            return false;
          });
        });
      });
    }
  },
  created() {}
};
</script>
<style lang="less" scoped>
.main-content-wrapper {
  padding-top: 20px;
  padding-bottom: 0 !important;
}
</style>
<style lang="less">
@color-main: #03B2B2;
.main-content-wrapper {
  .synchronous-right-box {
    min-height: calc(100vh - 110px - 70px);
    width: 984px;
    border-radius: 6px;
    margin-bottom: 20px;
    // background: #fff;
    display: inline-block;
    vertical-align: top;

    .top-title {
      .top-title-span {
        font-size: 16px;
        font-weight: 700;
        padding-left: 45px;
        color: #4a4a4a;
        display: inline-block;
        position: relative;
        &:before {
          content: "";
          display: inline-block;
          width: 14px;
          height: 14px;
          border-radius: 50%;
          background: rgba(0, 179, 138, 0.24);
          position: absolute;
          left: 40px;
          top: -5px;
        }
      }
      .top-title-line {
        margin-left: 22px;
        width: 912px;
        height: 1px;
        background: #e8e8e8;
        margin-top: 7px;
      }
    }
    .synchronous-resource-list {
      min-height: calc(100vh - 110px - 70px);
      padding-bottom: 20px; 
      position: relative;
      .resource-list-box {
        .resource-item {
          width: 314px;
          height: 300px;
          margin-bottom: 20px;
          &:nth-of-type(3n + 1),
          &:nth-of-type(3n + 2) {
            margin-right: 20px;
          }
          .resource-item-top {
            height: 178px;
            .resource-duration {
              bottom: 7px;
              right: 10px;
            }
            .free-tip {
            }
          }
          .resource-item-title {
            margin-top: 20px;
            padding: 0 15px;
          }
          .resource-bottom-box {
            padding: 0 15px;
          }
        }
        &.empty {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          p {
            text-align: center;
            height: 40px;
            line-height: 40px;
            color: #999;
          }
        }
      }
      .el-pagination {
        padding: 0;
        position: absolute;
        bottom: -2px;
        left: 50%;
        transform: translateX(-50%);
      }
    }
  }
  
}

</style>